module.exports = __webpack_public_path__ + "static/media/noticeMessage.5c2fb655.mp3";